export default {
    ConvertDDToDMS(D, lng) {
        let x = {
          dir: D < 0 ? (lng ? "W" : "S") : lng ? "E" : "N",
          deg: 0 | (D < 0 ? (D = -D) : D),
          min: 0 | (((D += 1e-9) % 1) * 60),
          sec: (0 | (((D * 60) % 1) * 6000)) / 100,
        }

        return `${x.dir}${x.deg}°${x.min}'${x.sec}"`
      }
}